export const download = (url: string, filename: string, extension: string): void => {
  fetch(url, {
    method: 'GET',
    headers: {},
  }).then((response) => {
    response.arrayBuffer().then(function (buffer) {
      const url = window.URL.createObjectURL(new Blob([buffer]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${filename}.${extension}`)
      link.click()
      link.remove()
    })
  })
}

const convertHeaderToCamelCase = (header: string): string => {
  const title = header.split(' ')
  let camelCaseHeader = ''
  title.forEach((word, index) => {
    word = word.toLowerCase()
    camelCaseHeader += index === 0 ? word : word[0].toUpperCase() + word.slice(1)
  })

  return camelCaseHeader
}

export const downloadCsv = (arrOfObj: any, fileHeaders: string[], fileDescription: string): void => {
  const replacer = (key: any, value: any): any => value ?? ''
  const csvFile = [
    fileHeaders.join(','),
    ...arrOfObj.map((row: any) => fileHeaders.map((header) => JSON.stringify(row[convertHeaderToCamelCase(header)], replacer)).join(',')),
  ].join('\n')
  const url = window.URL.createObjectURL(new Blob(['\ufeff', csvFile]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${fileDescription}.csv`)
  link.click()
  link.remove()
}
